import { useNavigate } from "react-router-dom";
import React, { useContext, } from "react";
import { AuthContext } from "../components/contexts/AuthContext";
import { Divider, Typography } from 'antd';
import PersonIcon from '@mui/icons-material/Person2TwoTone';
import PublicTwoToneIcon from '@mui/icons-material/PublicTwoTone';
import PlagiarismTwoToneIcon from '@mui/icons-material/PlagiarismTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import InsertPhotoTwoToneIcon from '@mui/icons-material/InsertPhotoTwoTone';
import MonetizationOnTwoToneIcon from '@mui/icons-material/MonetizationOnTwoTone';
import FactoryTwoToneIcon from '@mui/icons-material/FactoryTwoTone';
import SmartToyTwoToneIcon from '@mui/icons-material/SmartToyTwoTone';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';

const { Title, Paragraph, Text, Link } = Typography;

const ReportsAll = () => {
    const navigate = useNavigate();

    const { authState } = useContext(AuthContext);



    return (
        <div>
            <Typography>
                <Title>
                    BUSINESS REPORTS
                </Title>

                <div className="flex gap-3 cursor-pointer" onClick={() => navigate("/reports/overview")}>

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <SummarizeTwoToneIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            OVERALL SUMMARY
                        </div>
                    </div>

                </div>
                <Title>
                    Customer Reports
                </Title>

                <div className="flex gap-3 cursor-pointer">

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <PersonIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            CUSTOMERS
                        </div>
                    </div>

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <PublicTwoToneIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            COUNTRY WISE
                        </div>
                    </div>

                </div>

                <Title>
                    Enquiry Reports
                </Title>

                <div className="flex gap-3 cursor-pointer">

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <PlagiarismTwoToneIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            ENQUIRY INFO
                        </div>
                    </div>

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <SettingsTwoToneIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            PARTS INFO
                        </div>
                    </div>

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <InsertPhotoTwoToneIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            PARTS GALLERY
                        </div>
                    </div>

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <FactoryTwoToneIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            SUPPLIER INFO
                        </div>
                    </div>

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <SmartToyTwoToneIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            WA BOT INFO
                        </div>
                    </div>

                </div>


                <Title>
                    Finance Reports
                </Title>

                <div className="flex gap-3 cursor-pointer">

                    <div className="border rounded p-2 shadow-3 transition-all hover:scale-110">
                        <div className="flex justify-center">
                            <MonetizationOnTwoToneIcon />
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "600" }}>
                            GROSS PROFIT
                        </div>
                    </div>


                </div>

            </Typography>
        </div>
    );
}

export default ReportsAll;